import TravelInsuranceTypeForm from '@/modules/travel/rater/views/forms/TravelInsuranceTypeForm.vue'
import type FormPage from '@/modules/common/common/models/APP/FormPage'
import ForWhomForm from '@/modules/common/rater/views/forms/ForWhomForm.vue'
import TravelDestinationTypeForm from '@/modules/travel/rater/views/forms/TravelDestinationTypeForm.vue'
import TravelSportInsuranceForm from '@/modules/travel/rater/views/forms/TravelSportInsuranceForm.vue'
import TravelDurationForm from '@/modules/travel/rater/views/forms/TravelDurationForm.vue'
import TravelFromForm from '@/modules/travel/rater/views/forms/TravelFromForm.vue'
import TravelCancellationCoverageForm from '@/modules/travel/rater/views/forms/TravelCancellationCoverageForm.vue'

export default {
  ForWhom: {
    form: ForWhomForm,
    next: ['TravelFrom']
  },
  TravelFrom: {
    form: TravelFromForm,
    next: ['TravelInsuranceType']
  },
  TravelInsuranceType: {
    form: TravelInsuranceTypeForm,
    next: ['DestinationType', 'SportInsurance']
  },
  SportInsurance: {
    form: TravelSportInsuranceForm,
    next: ['DestinationType']
  },
  DestinationType: {
    form: TravelDestinationTypeForm,
    next: ['TravelDuration', 'TravelCancellationCoverage']
  },
  TravelCancellationCoverage: {
    form: TravelCancellationCoverageForm,
    next: ['TravelDuration']
  },
  TravelDuration: {
    form: TravelDurationForm,
    next: []
  }
} as Record<string, FormPage>
